var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.subjectProperties),function(property,i){return _c('span',{key:i},[_vm._v(" "+_vm._s(_vm.label(property))+" "),(_vm.expandable)?_c('SubjectPropertyExpander',{attrs:{"object":property}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }